module.exports = __webpack_public_path__ + "img/certificat3.fe3ce4b7.png";